import { get } from '../utils'
import { getActiveClient } from "../authentication/utils";


const url = (host, id) => `${host}/clients/${id}/quota`

export default host => (id = getActiveClient()) =>
  get(url(host, id))
    .then(response => response.json())